import verifyLabel from '../../../methods/verifyLabel'

export default {
    name: 'product-info',
    data(){
      return {}
    },
    computed:{
        data() {
            return this.$store.state.main.productInfo
        }
    },
    methods: {
        verifyLabel(displayName) {
            if (this.$store.state.main.labels) {
                return verifyLabel(displayName,this.$store.state.main.labels)
            } else {
                return ""
            }
        },
        scrollToConfigurator() {
            document.querySelector(".nti-configurator-tablist").scrollIntoView({behavior: "smooth", block: "start"});
        }
    }
}